import spartaDatepickerUtility from '@sparta.global.utilities/sparta-datepicker-utility/dist/es6.js';

/* global document, window, navigator */

/**
 * ASSUMPTIONS
 * 1. ONLY supported format MM/DD/YYYY
 * 2. No holidays/blocked dates are remembered by the utility, always needs to be passed
 * 3. No masking
 *
 * @note Sparta V6 Migraton note - This used to be a very comprehensive custom component.
 * This was migrated to use Sparta's Global Datepicker.
 */

/**
 * @param {HTMLInputElement} element element to add datepicker
 * @param {Object} options options/settings for the datepicker
 * @returns {null} nothing
 */
function initDatepicker(element, options) {
  spartaDatepickerUtility.init({
    selector: `#${element.id}`,
    minDate: '0',
    addBankHolidays: options.blockPassedDates ? options.blockDates : []
  });
}
var index = {
  initDatepicker
};

export { index as default };
